import { BrowserRouter, Routes, Route } from "react-router-dom"
import LoginPage from "./pages/LoginPage"
import GridEditor from "./pages/GridEditor"
import TemplateEditor from "./pages/TemplateEditor"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/editor" element={<GridEditor />} />
        <Route path="/plantilla" element={<TemplateEditor />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
